// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"9556a2a8","142":"a49eb9e1","239":"623d5ba4","312":"7de27652","453":"73477e0d","455":"522b5598","479":"1ba7b018","709":"64544251","857":"f1e8f9c9","860":"a0d872df","865":"f31bb758","977":"3807472b"}[chunkId] + ".chunk.js";
};